import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import RuthlessMentor from '@/components/RuthlessMentor';

export default function MentorPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
      <div className="max-w-5xl mx-auto px-4 py-6">
        <Button
          variant="ghost"
          className="text-slate-400 hover:text-white mb-4"
          onClick={() => navigate('/')}
          data-testid="mentor-page-back"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Dashboard
        </Button>

        <RuthlessMentor />
      </div>
    </div>
  );
}
